import { useIntelligenceTabRedesignEnabled } from '~/hooks/useIntelligenceTabRedesignEnabled';
import * as Intelligence from './intelligence/index';
import * as IntelligenceV2 from './intelligenceV2/index';

// Single Intelligence tab (route: `intelligence`). The org-targeted
// `intelligence-tab-redesign-enabled` flag (PSCO-127) selects which tab renders:
// the redesigned Intelligence tab when enabled, the legacy Intelligence tab otherwise.
export function TabDetails() {
  const { resolved, enabled } = useIntelligenceTabRedesignEnabled();
  if (!resolved) {
    return null;
  }
  return enabled ? <IntelligenceV2.TabDetails /> : <Intelligence.TabDetails />;
}

// Flag-routed map children: the redesigned Intelligence tab's map content when enabled, else the legacy tab's.
export function MapChildren() {
  const { resolved, enabled } = useIntelligenceTabRedesignEnabled();
  if (!resolved) {
    return null;
  }
  return enabled ? <IntelligenceV2.MapChildren /> : <Intelligence.MapChildren />;
}
